import React, { useState } from 'react';
import { Button, Flex, Text, TextField, PasswordField, Alert } from '@aws-amplify/ui-react';
import { Amplify, Auth } from 'aws-amplify';
import { useSearchParamsValue } from '~/shared/hooks';

const amplifyconfig: any = {
  Auth: {
    region: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
    userPoolId: process.env.REACT_APP_COGNITO_POOL_ID || 'us-east-1_sr2n4d09I',
    userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '13j6amf303a03dulhciq0vsahc',
    mandatorySignIn: false,
  },
};

Amplify.configure(amplifyconfig);

function ResetPasswordScreen() {
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  const searchParams = useSearchParamsValue();

  const [error, setError] = useState('');

  async function changePassword(e: any) {
    e.preventDefault();
    const email = searchParams.email;
    const code = searchParams.verification_code;
    try {
      await Auth.forgotPasswordSubmit(email, code, password);
      window.open('/');
    } catch (error: any) {
      setError(error.message);
    }
  }

  return (
    <div className="reset-password-wrapper">
      <img alt="mktmediastats" style={{ width: 300, marginBottom: '25px', display: 'flex' }} src="/LoginLogo.png" />
      <div className="reset-password-card ">
        <h5 className="amplify-heading amplify-heading--5 reset-password-title">Reset your password</h5>
        <Flex
          as="form"
          direction="column"
          width="calc(100% - 32px)"
          placeholder="Reset your password"
          onPointerEnterCapture={null}
          onPointerLeaveCapture={null}
          onSubmit={changePassword}
        >
          <TextField
            crossOrigin={null}
            onPointerEnterCapture={null}
            onPointerLeaveCapture={null}
            label={
              <Text placeholder="Code" onPointerEnterCapture={null} onPointerLeaveCapture={null}>
                Code
              </Text>
            }
            type="number"
            isRequired={true}
            isReadOnly={true}
            defaultValue={searchParams.verification_code}
          />
          <PasswordField
            label="New Password*"
            name="newPasswordFake"
            crossOrigin={null}
            onPointerEnterCapture={null}
            onPointerLeaveCapture={null}
            isRequired={true}
            defaultValue="hello"
            className="reset-password-fake-field"
          />
          <PasswordField
            label="New Password*"
            name="newPassword"
            crossOrigin={null}
            onPointerEnterCapture={null}
            onPointerLeaveCapture={null}
            isRequired={true}
            onChange={(e: any) => {
              setPassword(e.target.value);
            }}
            value={password}
          />
          <PasswordField
            label="Confirm Password*"
            name="newPasswordConfirmed"
            crossOrigin={null}
            onPointerEnterCapture={null}
            onPointerLeaveCapture={null}
            isRequired={true}
            onChange={(e: any) => {
              setPasswordConfirm(e.target.value);
            }}
            value={passwordConfirm}
            hasError={passwordConfirm !== '' && passwordConfirm !== password}
            errorMessage="Your passwords must match"
          />
          {error && (
            <Alert placeholder="Alert" onPointerEnterCapture={null} onPointerLeaveCapture={null} variation="error">
              {error}
            </Alert>
          )}
          <Button
            type="submit"
            className="amplify-button amplify-field-group__control amplify-button--primary amplify-button--fullwidth reset-password-button"
            placeholder="Submit"
            onPointerEnterCapture={null}
            onPointerLeaveCapture={null}
          >
            Reset Password
          </Button>
        </Flex>
      </div>
    </div>
  );
}

export default ResetPasswordScreen;
